export default {"src":"/_next/static/media/twitter.f6d0eb5a.svg","height":18,"width":18};